var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageShell',{staticClass:"page-shell-wrapper--legal",attrs:{"locale":"id","page-title":_vm.pageTitle}},[_c('LegalContent',{attrs:{"slug":"privacy"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }